
import { motion } from "framer-motion";
import { CircleImage } from "./CircleImage";

interface AnimatedBackgroundProps {
  isMenuOpen: boolean;
}

const circles = [
  {
    imageSrc: "/lovable-uploads/942e60b2-8b0b-470f-8b06-c15677878308.png",
    borderColor: "#0073B7"
  },
  {
    imageSrc: "/lovable-uploads/a66b5784-3a53-423e-a6f6-3d36a880e8f3.png",
    borderColor: "#E60026"
  },
  {
    imageSrc: "/lovable-uploads/2a5e8804-3865-42c0-b50e-c945e9053d4b.png",
    borderColor: "#0073B7"
  },
  {
    imageSrc: "/lovable-uploads/8ce5dca4-88f4-4943-9081-c60538bfaa45.png",
    borderColor: "#E60026"
  },
  {
    imageSrc: "/lovable-uploads/d5ebf08b-6d27-4f4a-8309-3458085ac37c.png",
    borderColor: "#0073B7"
  },
  {
    imageSrc: "/lovable-uploads/883f7bed-8d0d-49db-a665-e8a2991cbbbf.png",
    borderColor: "#E60026"
  },
  {
    imageSrc: "/lovable-uploads/a1fac709-2dd7-46f2-a6e3-f62dbe3ff6a2.png",
    borderColor: "#0073B7"
  },
  {
    imageSrc: "/lovable-uploads/ac958e4b-e853-4f71-bb75-c268dea3700a.png",
    borderColor: "#E60026"
  },
  {
    imageSrc: "/lovable-uploads/27bbbc42-711e-4660-a920-1242d39d6491.png",
    borderColor: "#0073B7"
  },
  {
    imageSrc: "/lovable-uploads/32e25a4d-eaef-4090-866f-8f2bc9921318.png",
    borderColor: "#E60026"
  },
  {
    imageSrc: "/lovable-uploads/155c221c-7fa3-4947-90ed-e61f04210ff3.png",
    borderColor: "#0073B7"
  },
  {
    imageSrc: "/lovable-uploads/20555031-da93-4a9b-96d9-28f912aa2d3e.png",
    borderColor: "#E60026"
  },
  {
    imageSrc: "/lovable-uploads/7a519232-7d88-4323-990b-7b04dc6c599c.png",
    borderColor: "#0073B7"
  },
  {
    imageSrc: "/lovable-uploads/9cfd0914-b389-45b7-8677-cc23860e7146.png",
    borderColor: "#E60026"
  },
  {
    imageSrc: "/lovable-uploads/0b532b4c-351d-47d3-a65d-44d2e287685c.png",
    borderColor: "#0073B7"
  }
];

export const AnimatedBackground = ({ isMenuOpen }: AnimatedBackgroundProps) => {
  return (
    <motion.div 
      className="absolute inset-0 overflow-hidden"
      animate={{ scale: isMenuOpen ? 0.95 : 1 }}
      transition={{ duration: 0.3 }}
    >
      {circles.map((circle, index) => (
        <>
          {[0, 1, 2].map((depth) => (
            <CircleImage
              key={`${index}-${depth}`}
              imageSrc={circle.imageSrc}
              borderColor={circle.borderColor}
              index={index}
              depth={depth}
            />
          ))}
        </>
      ))}
    </motion.div>
  );
};
